import axios from "axios"

import { getNodeBaseUrl } from "./utils"

export const postReqregEarthDataExists = async (wallet: string) => {
  const res = await axios.post(getNodeBaseUrl() + "/reqreg_earth_data_exists", { wallet })
  return res.data
}
